import React, { useState, createContext, useContext } from 'react'
import { AbilityContext } from '../../../contexts/abilityContext'
import { CurrentUserContext } from '../../../contexts/currentUserContext'

export const SelectedUserContext = createContext({} as any)

const SelectedUserContextProvider = (props: any) => {
  const currentUser: any = useContext(CurrentUserContext)
  const ability: any = useContext(AbilityContext)
  const canFullAccess = ability.can('overview', 'Conformity')

  const [selectedUser, setSelectedUser] = useState<number | undefined>(
    canFullAccess ? undefined : currentUser.id
  )

  return (
    <SelectedUserContext.Provider
      value={{
        selectedUser: selectedUser,
        setSelectedUser: setSelectedUser,
        canFullAccess: canFullAccess,
      }}
    >
      {props.children}
    </SelectedUserContext.Provider>
  )
}

export default SelectedUserContextProvider
